import { Div } from '@codesuma/baseline'
import { IDayCell } from '../../services/calendar'
import settings from '../../services/settings'
import { solarYear, paleYear } from '../../helpers/year'
import { YearLink } from '../../components/year-link'
import { pullDown } from '../../helpers/pull-down'
import { MonthCard } from './month-card'
import style from './index.module.css'

// One whole year inside a slider slide: the year over twelve month cards, each
// card a full month grid with the days' own colours on it. Three across and
// four down, sized to the screen — the year is meant to be taken in at a
// glance, so nothing here scrolls.
//
// Taps travel up as 'day-open' (a date), 'month-open' (a home slider index) and
// 'century-open' (a year) for the page to route on.
export const YearSlide = (year: number) => {
    const base = Div()
    base.addClass(style.slide)

    const { system } = settings.get()
    // Gregorian months read left-to-right, so the cards fill that way too:
    // January in the leading corner on the left, not on the right.
    if (system === 'gregorian') base.attr('dir', 'ltr')

    // The year opens the years view, the way the month title's year opens this
    // page — the same component, so the mark means the same at every level.
    const title = Div()
    title.addClass(style.title)
    const link = YearLink(paleYear(system === 'gregorian' ? String(year) : solarYear(year)), 'نمای سال‌ها')
    link.on('open', () => base.emit('century-open', year))
    title.append(link)
    base.append(title)

    const grid = Div()
    grid.addClass(style.months)
    base.append(grid)

    // The other way up a level: carry on past the top of the cards.
    pullDown(base, grid.el)
    base.on('pull-down', () => base.emit('century-open', year))

    for (let m = 1; m <= 12; m++) {
        const card = MonthCard(year, m, system)
        card.on('day-open', (c: IDayCell) => base.emit('day-open', c))
        card.on('month-open', (index: number) => base.emit('month-open', index))
        grid.append(card)
    }

    return base
}
